/**
 * @generated SignedSource<<5e7942be201a7903c997ac37d1f1ea2c>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RolePickerListItem_role",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        }
    ],
    "type": "Role",
    "abstractKey": null
};
node.hash = "07f86610a62cefab83779fbc5ba6ef6d";
export default node;
